import { Controller } from "@hotwired/stimulus"
import controller from "../utils/controller"

export default class extends Controller {
  static targets = ["submitButton", "filtersButton", "clearButton", "filterField", "modalClearButton", "modal"]

  connect() {
    this.submitLabel = this.submitButtonTarget.innerText
    this.filtersLabel = this.filtersButtonTarget.innerText

    this.showAppliedFiltersCount()
  }

  disconnect() {
    this.submitButtonTarget.textContent = this.submitLabel
    this.filtersButtonTarget.textContent = this.filtersLabel
  }

  open() {
    this.modal.open()
  }

  showAppliedFiltersCount() {
    this.submitButtonTarget.textContent = `${this.submitLabel} (${this.countFields()})`
    this.filtersButtonTarget.textContent = `${this.filtersLabel} (${this.countFields()})`

    this.clearButtonTarget.toggleAttribute("disabled", this.countFields() === 0)
    this.modalClearButtonTarget.toggleAttribute("disabled", this.countFields() === 0)
  }

  updateFieldCount(event) {
    this.showAppliedFiltersCount()
  }

  updateSubmitButtonCount(event) {
    this.submitButtonTarget.textContent = `${this.submitLabel} (${this.countFields()})`

    this.modalClearButtonTarget.toggleAttribute("disabled", this.countFields() === 0)
  }

  countFields() {
    return this.filterFieldTargets.filter(field => field.value).length
  }

  clearForm() {
    this.filterFieldTargets.forEach(element => {
      if (element.type !== "submit") {
        if (element.value) {
          element.value = ""
        }
      }
      if (element.classList.value === "form-control selectized") {
        element.selectize.clear()
      }
    })
  }

  submit() {
    this.element.requestSubmit()
  }

  get modal() {
    return controller(this.modalTarget, "modal")
  }
}
